import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';
import { SignupForm } from 'views/Signup/SignupForm';
import imgRegistro from 'assets/images/ilustracion-registro.svg';
import ButtonComponent from 'components/design-system/Button/Button';
import { Done, NavigateBefore, Save } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useEffect } from 'react';

export const RegistroUsuario = ({
  errors,
  handleBlur,
  handleChange,
  ingresandoDatosUsuario,
  initialValues,
  isSubmitting,
  onVolver,
  resetForm,
  setFieldTouched,
  setFieldValue,
  setIngresandoDatosUsuario,
  terminosAceptados,
  touched,
  validateForm,
  values,
  setTouched,
  setSubmitting,
  setErrors
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {}, [initialValues, setTouched]);

  return (
    <div className="grid grid-cols-12">
      <div className="col-span-12 md:col-span-6">
        <Heading type="h3">Registrar un usuario</Heading>
        <Text className="mb-4">
          Registrar un usuario te permitirá posteriormente acceder a la
          plataforma a visualizar también la información del negocio.
        </Text>
        <SignupForm
          values={values}
          errors={errors}
          touched={touched}
          handleChange={handleChange}
          handleBlur={handleBlur}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          validateForm={validateForm}
          cargando={false}
          correoInvitado={null}
          showBotonRegistro={false}
          customDisabled={{
            email: true // Deshabilitar el campo email
          }}
        />
      </div>
      <div className="col-span-6 p-16 hidden md:block">
        <img src={imgRegistro} alt="" />
      </div>
      <div className="absolute bottom-0 w-full shadow-md rounded-bl rounded-br bg-white px-4 sm:px-10 py-4 border-t left-0">
        <div className="flex justify-between">
          {/* Botón "Volver" (visible en todas las pantallas) */}
          <ButtonComponent
            type="secondary"
            className="justify-center"
            onClick={onVolver}
            disabled={isSubmitting}
          >
            {/* Mostrar ícono en pantallas pequeñas y texto en pantallas grandes */}
            <Box sx={{ display: { xs: 'block', sm: 'block' } }}>
              <NavigateBefore /> {/* Ícono de flecha hacia atrás */}
            </Box>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              Volver {/* Texto en pantallas grandes */}
            </Box>
          </ButtonComponent>
          <ButtonComponent
            form="confirmarRegistroAdministracion"
            type="primary"
            buttonType="submit"
            isLoading={isSubmitting}
            disabled={
              isSubmitting ||
              Object.keys(errors).length > 0 ||
              !terminosAceptados
            }
            className="w-full xs:w-auto justify-center"
            onClick={() => {}}
          >
            <>
              {/* Mostrar "Guardar" en pantallas grandes (sm y mayores) */}
              <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                Aprobar solicitud <Done />
              </Box>

              {/* Mostrar el ícono "Save" en pantallas pequeñas (xs) */}
              <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                {<Done />}
              </Box>
            </>
          </ButtonComponent>
        </div>
      </div>
    </div>
  );
};
